import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowRight } from 'react-icons/hi';

const AdminBackLink: React.FC = () => (
  <Link to="/dashboard" className="admin-back-link" aria-label="العودة إلى لوحة التحكم">
    <span className="admin-back-icon" aria-hidden="true">
      {React.createElement(HiOutlineArrowRight as any)}
    </span>
    <span>العودة</span>
  </Link>
);

export default AdminBackLink;
